import { RequestOptions } from '@angular/http';
import { HttpService } from './http/http.service';
import { HttpCacheService } from './http/http-cache.service';
export function createHttpService(backend, defaultOptions, httpCacheService) {
    return new HttpService(backend, defaultOptions, httpCacheService);
}
var CoreModule = /** @class */ (function () {
    function CoreModule(parentModule) {
        // Import guard
        if (parentModule) {
            throw new Error(parentModule + " has already been loaded. Import Core module in the AppModule only.");
        }
    }
    return CoreModule;
}());
export { CoreModule };



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts.pre-build-optimizer.js